// extracted by mini-css-extract-plugin
export default {"slider":"BlindControlSlider_slider__vCYuK"};